import { useSelector } from 'react-redux';

import { TabModules } from '~/data/company/index';
import { Modules } from '~/data/modules';
import { StoreState } from '~/reducer';
import { companyDataStateSelector } from '~/selectors';
import { AppModules } from '~/services/Permissions';

type ModuleKey = string | AppModules | TabModules | Modules;

export type UseModulesConfigOutput = {
  enabledModules: string[];
  getEnabledTabsForModule: (module: TabModules) => string[];
  isTabbedModule: (module: ModuleKey) => boolean;
  isModuleEnabled: (module: ModuleKey) => boolean;
  isModuleTabEnabled: (module: TabModules, tab: string) => boolean;
  isLoading: boolean;
  hasData: boolean;
};

export const useModulesConfig = (): UseModulesConfigOutput => {
  const { modules, isLoading, hasData } = useSelector((state: StoreState) => {
    return companyDataStateSelector(state);
  });

  const { enabledModules, enabledTabs } = modules;

  const isModuleEnabled = (module: ModuleKey) =>
    enabledModules.includes(module);

  const isTabbedModule = (module: ModuleKey) =>
    Object.values(TabModules)
      .map((t) => t.toString())
      .includes(module);

  const getEnabledTabsForModule = (module: TabModules) => enabledTabs[module];

  const isModuleTabEnabled = (module: TabModules, tab: string) =>
    isModuleEnabled(module) && getEnabledTabsForModule(module).includes(tab);

  return {
    enabledModules,
    getEnabledTabsForModule,
    isTabbedModule,
    isModuleEnabled,
    isModuleTabEnabled,
    isLoading,
    hasData,
  };
};
